import React, { useRef, useState, useEffect } from "react";
import styles from "./DeliveryDeviceModalContent.module.css";

import { ManagerDevices3Dots } from "../../icons/Icon";
import ManagerModal from "../Manager/ManagerModal";

// ─────────────────────────────────────────────
// Status Badge
// ─────────────────────────────────────────────
const StatusBadge = ({ status }) => {
  const active =
    String(status).toLowerCase() === "active" ||
    String(status).toLowerCase() === "accepted";

  return (
    <div
      className={`${styles.statusBadge} ${
        active ? styles.statusActive : styles.statusInactive
      }`}
    >
      <span className={styles.statusDot} />
      {status || "Unknown"}
    </div>
  );
};

// ─────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────
const DeliveryDeviceModalContent = ({
  mode = false,
  data = [],
  loading = false,
  toggleModel,
  setModeleState,
  handleOptionClick,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(null);

  const dropdownRefs = useRef({});

  // CLOSE DROPDOWN OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownVisible !== null &&
        dropdownRefs.current[dropdownVisible] &&
        !dropdownRefs.current[dropdownVisible].contains(event.target)
      ) {
        setDropdownVisible(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownVisible]);

  // TOGGLE DROPDOWN
  const toggleDropdown = (index) => {
    setDropdownVisible((prev) => (prev === index ? null : index));
  };

  // OPEN CONFIRM MODAL
  const openConfirmModal = ({
    heading,
    centerHeading,
    subHeading,
    targetWord,
    actionType,
    item,
  }) => {
    setDropdownVisible(null);

    toggleModel(
      <ManagerModal
        heading={heading}
        centerHeading={centerHeading}
        subHeading={subHeading}
        targetWord={targetWord}
        handleCloseModal={() => setModeleState(false)}
        handleSubmit={() => {
          handleOptionClick(actionType, item);
          setModeleState(false);
        }}
      />
    );
  };

  const columns = [
    "Login ID",
    "Name",
    "Device ID",
    "Device OS",
    "Device Name",
    "Status",
    "Actions",
  ];

  return (
    <div className={`${styles.wrapper} ${mode ? styles.dark : styles.light}`}>
      <div className={styles.scrollArea}>
        {/* HEADER */}
        <div className={styles.headerRow}>
          {columns.map((item, index) => (
            <div key={index} className={styles.headerCell}>
              {item}
            </div>
          ))}
        </div>

        {/* EMPTY */}
        {!loading && data.length === 0 && (
          <div className={styles.emptyState}>
            <span>No data found</span>
          </div>
        )}

        {/* LOADING */}
        {loading &&
          Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className={styles.skeletonRow}>
              {Array.from({ length: 7 }).map((__, i) => (
                <div key={i} className={styles.skeletonCell} />
              ))}
            </div>
          ))}

        {/* ROWS */}
        {!loading &&
          data.map((e, index) => (
            <div key={index} className={styles.row}>
              {/* Login ID */}
              <div className={styles.cell}>{e?.loginId || "—"}</div>

              {/* Name */}
              <div className={styles.cell}>{e?.partnerName || "—"}</div>

              {/* Device ID */}
              <div className={styles.cell}>{e?.deviceId || "—"}</div>

              {/* Device OS */}
              <div className={styles.cell}>{e?.deviceOS || "—"}</div>

              {/* Device Name */}
              <div className={styles.cell}>{e?.deviceName || "—"}</div>

              {/* Status */}
              <div className={styles.cell}>
                <StatusBadge status={e?.DeviceStatus} />
              </div>

              {/* ACTION */}
              <div className={`${styles.cell} ${styles.actionCell}`}>
                <button
                  className={styles.actionBtn}
                  onClick={(event) => {
                    event.stopPropagation();
                    toggleDropdown(index);
                  }}
                >
                  <ManagerDevices3Dots
                    color={mode ? "#ffffff" : "#1C274C"}
                  />
                </button>

                {/* DROPDOWN */}
                {dropdownVisible === index && (
                  <div
                    className={styles.dropdown}
                    ref={(el) => (dropdownRefs.current[index] = el)}
                  >
                    {/* ACCEPT */}
                    <div
                      className={styles.dropdownItem}
                      onClick={() =>
                        openConfirmModal({
                          heading: "Accept Request",
                          centerHeading:
                            "Are you sure you want to Accept?",
                          subHeading:
                            "To confirm! type accept in the text field.",
                          targetWord: "accept",
                          actionType: "Active",
                          item: e,
                        })
                      }
                    >
                      Accept
                    </div>

                    {/* DISABLE */}
                    <div
                      className={styles.dropdownItem}
                      onClick={() =>
                        openConfirmModal({
                          heading: "Disabled Request",
                          centerHeading:
                            "Are you sure you want to disabled?",
                          subHeading:
                            "To confirm! type disabled in the text field.",
                          targetWord: "disabled",
                          actionType: "Disabled",
                          item: e,
                        })
                      }
                    >
                      Disable
                    </div>

                    {/* DELETE */}
                    <div
                      className={`${styles.dropdownItem} ${styles.deleteItem}`}
                      onClick={() =>
                        openConfirmModal({
                          heading: "Delete Request",
                          centerHeading:
                            "Are you sure you want to Delete?",
                          subHeading:
                            "To confirm! type delete in the text field.",
                          targetWord: "delete",
                          actionType: "Delete",
                          item: e,
                        })
                      }
                    >
                      Delete
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DeliveryDeviceModalContent;